// extracted by mini-css-extract-plugin
export default {"table":"Table_table__7LDjD","th":"Table_th__ocz-X","td":"Table_td__ZlPDA","tr":"Table_tr__i3VaO"};